/** @file Overlay palette (packed straight-alpha colours) and pixel sizes shared by every layer. */
import { color } from '@pose2d/math/color';

const hex = (text: string): number => color.parseHex(text);

/** Colours are `math/color.pack` words; sizes are screen pixels (constant whatever the zoom). */
export const OVERLAY_STYLE = {
  /** Bone fill by hierarchy depth (root = 0), cycling. */
  boneDepth: [hex('#4fc3f7e6'), hex('#81c784e6'), hex('#ffb74de6'), hex('#ba68c8e6'), hex('#f06292e6')],
  boneOutline: hex('#101418ff'),
  joint: hex('#ffffffff'),
  selected: hex('#ffeb3bff'),
  socket: hex('#00e5ffff'),
  ik: hex('#ff9800ff'),
  meshEdge: hex('#ffffffa0'),
  hullEdge: hex('#ffd54fff'),
  vertex: hex('#ffffffff'),
  grid: hex('#ffffff40'),
  footprintFill: hex('#4caf5050'),
  footprintEdge: hex('#4caf50e0'),
  axisX: hex('#ef5350ff'),
  axisY: hex('#66bb6aff'),
  tickText: hex('#e0e0e0ff'),
  labelBox: hex('#000000a0'),
  labelText: hex('#ffffffff'),
  leader: hex('#ffffffb0'),
  onionBefore: hex('#ff5a5aff'),
  onionAfter: hex('#5ad25aff'),
  diff: hex('#ff40ffff'),
  /** Trail colour per requested bone, cycling. */
  trail: [hex('#00e5ffff'), hex('#ffea00ff'), hex('#ff4081ff'), hex('#76ff03ff')],
  /** `weights:dominant` colour per bone index, cycling. */
  dominant: [
    hex('#e6194bff'), hex('#3cb44bff'), hex('#ffe119ff'), hex('#4363d8ff'),
    hex('#f58231ff'), hex('#911eb4ff'), hex('#46f0f0ff'), hex('#f032e6ff'),
  ],
  lineWidth: 1.5,
  jointRadius: 3.5,
  vertexRadius: 2.5,
  labelPad: 2,
  labelGap: 4,
  /** Grid and tick spacing never get denser than this many pixels. */
  minGridPx: 8,
  minTickPx: 64,
  /** Upper bound on lines per direction for the grid and for the footprint's tile lines (R7-01). */
  maxGridLines: 1024,
  /** Labels one layer (names, vertex ids) places at most; its later requests are dropped and reported (C12). */
  maxLabelsPerLayer: 2000,
} as const;
